import { ConfirmModal, EasyCheckin } from '@innovatrics/checkin-components'
import { Grid, Link } from '@mui/material'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useLastCustomer } from '../components/LastCustomerContext'
import { useGetLastCustomerSubscription } from '../generated/graphql'

export const TopBar = () => {
  const navigate = useNavigate()
  const { hash } = useParams()
  const [modalVisible, setModalVisible] = useState(false)

  const [confirmed, setConfirmed] = useState(false)
  // const [res] = useGetLastCustomerSubscription({ variables: { customerId } })
  // res

  const [res] = useLastCustomer()

  useEffect(() => {
    if (res?.data?.checkinCustomer?.isConfirmed) setConfirmed(true)
  }, [res])

  const handleNavigate = () => {
    setModalVisible(false)
    navigate(`/reset/${hash}`)
  }

  return (
    <Grid
      container
      position={'fixed'}
      borderTop={'10px solid #42BE65'}
      borderBottom={'1px solid #E6E8EC'}
      justifyContent={'center'}
      alignItems={'center'}
      height={'110px'}
      sx={{ backgroundColor: '#fff' }}
      zIndex={5}
    >
      <Grid
        item
        container
        justifyContent={'center'}
        alignItems={'center'}
        maxWidth={'1200px'}
      >
        <Link
          onClick={() => {
            confirmed || !res?.data
              ? navigate(`/reset/${hash}`)
              : setModalVisible(true)
          }}
          underline="none"
          sx={{ cursor: 'pointer' }}
        >
          <EasyCheckin />
        </Link>
      </Grid>
      <ConfirmModal
        name={'customer.return'}
        modalOpen={modalVisible}
        setModalOpen={setModalVisible}
        handleClick={handleNavigate}
      />
    </Grid>
  )
}
